// extracted by mini-css-extract-plugin
export default {"productDescription":"Eea-z","featuredDescription":"Fea-z","description":"Gea-z","more":"Hea-z","descriptionSku":"Iea-z"};